import { keepPreviousData, queryOptions } from '@tanstack/react-query';

import { useLocalizationStore } from '$/components/core/Localization/hooks/useLocalizationStore';
import { STANDARD_STALE_TIME } from '$/services/constants';
import {
  getAdminCollections,
  getFilterOptions,
  getUnfilteredFilterOption,
} from '$/services/usecases/filter';
import {
  type MaterialFilterOption,
  type SpectrumWidgetRequest,
} from '$/services/usecases/materials';
import { type FilterType } from '$/services/usecases/materials/mapper/materials';

export const filterOptionsQuery = ({
  type,
  filter,
  spectrumWidget,
  includeCredentials,
}: {
  type?: FilterType;
  filter?: MaterialFilterOption[];
  spectrumWidget?: SpectrumWidgetRequest;
  includeCredentials?: boolean;
} = {}) =>
  queryOptions({
    queryKey: [
      'filter_options',
      type,
      filter,
      spectrumWidget,
      includeCredentials,
      useLocalizationStore.getState().language,
    ],
    queryFn: ({ signal }) =>
      getFilterOptions(
        { type, filter, spectrumWidget, includeCredentials },
        signal,
      ),
    staleTime: STANDARD_STALE_TIME,
    placeholderData: spectrumWidget ? undefined : keepPreviousData,
  });

export const producerOptionsQuery = queryOptions({
  queryKey: ['producer'],
  queryFn: ({ signal }) => getUnfilteredFilterOption('producer', signal),
  staleTime: STANDARD_STALE_TIME,
});

export const collectionsQuery = queryOptions({
  queryKey: ['collections'],
  queryFn: ({ signal }) => getUnfilteredFilterOption('collection', signal),
  staleTime: STANDARD_STALE_TIME,
});

export const adminCollectionsQuery = () =>
  queryOptions({
    queryKey: ['admin_collections', useLocalizationStore.getState().language],
    queryFn: ({ signal }) => getAdminCollections(signal),
  });
